import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const FadeInOnScroll = ({ children, yOffset = 30, duration = 1.2, delay = 0.5, className = '' }) => {
  const el = useRef(null);

  useEffect(() => {
    gsap.fromTo(
      el.current,
      { y: yOffset, opacity: 0 },
      {
         y: '0',
        opacity: 1,
        duration,
        ease: 'power1.out',
        delay,
        stagger: 0.1,
        // ease: 'power2.out',
        scrollTrigger: {
          trigger: el.current,
          // end: "top bottom",
          start: 'top 90%',
          toggleActions: 'play none none none',
        },
      }
    );

    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, [yOffset, duration, delay]);

  return (
    <div ref={el} className={className}>
      {children}
    </div>
  );
};

export default FadeInOnScroll;
